<template>
  <div ref="columnarChart"></div>
</template>

<script>
import { columnarOption } from "@/views/report/indicators/option/columnarOption"
import * as echarts from "echarts";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
     
    }
  },
  computed: {
    ...mapGetters(['columnarData']),
  },
  watch: {
    columnarData: {
      deep: true,
      handler(newVal, oldVal) {
        this.initCharts();
      }
    },
  },
  methods: {
    setChartStyle() {
      // this.$refs.radarChart.style.height =
      //   (document.documentElement.clientHeight - 77) / 2 + "px";
    },
    initCharts() {

      var myChart = echarts.init(this.$refs.columnarChart);
      const category = this.columnarData.map(p => p.month + "月");
      columnarOption.xAxis.data = category;
      columnarOption.series[0].data = this.columnarData.map(p => p.score);
      myChart.setOption(columnarOption)

      myChart.resize();
      const resizeHandler = () => {
        this.setChartStyle();
        myChart && myChart.resize();
      };

      window.addEventListener('resize', resizeHandler);
    }
  },
  created() { },
  mounted() {

    // this.getIndexMsg();
  }
}
</script>

<style lang=scss>
// #lineDiv {
//   width: 500px;
//   height: 300px;
//   border: 1px solid red;
// }</style>